import { render, staticRenderFns } from "./AValiderPoulain.vue?vue&type=template&id=23cd0112&"
import script from "./AValiderPoulain.vue?vue&type=script&lang=js&"
export * from "./AValiderPoulain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports